import { render } from "./promoCodesMenu.vue?vue&type=template&id=99ec8c04"
import script from "./promoCodesMenu.vue?vue&type=script&lang=js"
export * from "./promoCodesMenu.vue?vue&type=script&lang=js"

import "./promoCodesMenu.vue?vue&type=style&index=0&id=99ec8c04&lang=css"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__